import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {

	return {
		// mobile css
		mobileVideosContainer: {
			overflowX           : "auto",
			gridAutoFlow        : "column",
			gridAutoColumns     : "80%",
			gridTemplateColumns : "unset",
			gridGap             : "1rem",
			display             : "grid",

			// remove scrollbar
			msOverFlowStytle       : "none", /* Internet Explorer 10+ */
			scrollBarWidth         : "none", /* Firefox */
			"&::-webkit-scrollbar" : {
				display: "none" /* Safari and Chrome */
			}
		},

		// video card
		mobileVideoCardContainer: {
			position : "relative",
			height   : "fit-content"
		},
		imageContainer: {
			paddingTop: "56.25%"
		},
		image: {
			top          : "0%",
			position     : "absolute",
			objectFit    : "cover",
			aspectRatio  : "16 / 9",
			borderRadius : "1rem"
		},

		tagsContianer: {
			position : "absolute",
			top      : "0%",
			display  : "flex"
		},

		cardInfoContainer: {
			position   : "absolute",
			display    : "flex",
			bottom     : "0",
			left       : "0",
			alignItems : "center",
			width      : "100%",
			padding    : "10px"
		},

		backgroundOverlay: {
			position     : "absolute",
			background   : "linear-gradient(180deg,transparent,rgba(0,0,0,.008) 11.79%,rgba(0,0,0,.031) 21.38%,rgba(0,0,0,.067) 29.12%,rgba(0,0,0,.115) 35.34%,rgba(0,0,0,.172) 40.37%,rgba(0,0,0,.239) 44.56%,rgba(0,0,0,.312) 48.24%,rgba(0,0,0,.39) 51.76%,rgba(0,0,0,.472) 55.44%,rgba(0,0,0,.556) 59.63%,rgba(0,0,0,.64) 64.66%,rgba(0,0,0,.724) 70.88%,rgba(0,0,0,.804) 78.62%,rgba(0,0,0,.88) 88.21%,rgba(0,0,0,.95))",
			width        : "100%",
			bottom       : "0",
			height       : "50%",
			borderRadius : "0 0 1rem 1rem"
		},

		profileImg: {
			height       : "4rem",
			width        : "4rem",
			borderRadius : "100%",
			marginRight  : "1rem"
		},

		videoTitle: {
			fontSize   : "1.4rem",
			fontWeight : "500"
			// width    : "35%"
		},

		creatorName: {
			fontSize: "1.2rem"
		},
		durationTag: {
			margin       : "0.8rem",
			borderRadius : "0.5rem"
		},
		ellipse: {
			color           : theme.other.paletteNew.darkModeWhite80,
			width           : "4px",
			height          : "4px",
			margin          : "0rem 0.7rem",
			borderRadius    : "50%",
			backgroundColor : "#fff"
		}
	};
} );

